module.exports = __webpack_public_path__ + "static/media/Resume_Austin_Wong.c441532b.pdf";